// extracted by mini-css-extract-plugin
export default {"content-wrapper":"Ko3tz","content-block":"lgS_F","sticker-skill":"FvBW7"};